import React from 'react';
import { withLayout } from 'helpers';
import sideImage from 'assets/ttu/ttu-step-3.avif';
import bottomGraphic from 'assets/ttu/bottom-2.avif';
import { StepButtons } from '../components/StepButtons';
import { SideImageContainer } from '../components/SideImageContainer';
import { GenericDecoration } from '../components/GenericDecoration';

function QuestionnaireStartScreen(props) {
  return (
    <SideImageContainer
      sideImage={sideImage}
      decorationComponent={
        <GenericDecoration
          bottomGraphicSrc={bottomGraphic}
          hideDecorationOnDesktop
        />
      }
      hideBottomGraphicOnDesktop>
      <div className="header">
        <StepButtons
          onBack={() => props.history.push(props.prevRoute)}
          onNext={() => {
            props.history.push(props.nextRoute);
          }}
        />
      </div>

      <div className="right-content">
        <h2 className="blue label state_title">
          Over 90% of Nue life patients report improvements in their anxiety,
          depression and PTSD symptoms after treatment.
        </h2>

        <p className="subtitle2">
          This brief (2 minute) assessment will help our clinicians determine if
          Nue Life is right for you.
        </p>
      </div>
    </SideImageContainer>
  );
}

QuestionnaireStartScreen.title = 'Start of Nue Life Questionnaire';

export default withLayout(QuestionnaireStartScreen);